import React from 'react';

export function ZaggleStartDeclaring({ onStart }: { onStart: () => void }) {

  return <div className={'flex justify-center'}>
    <button onClick={onStart} className={'btn btn--primary'}>
      Start Declaring
    </button>
  </div>;
}